import { createRoutine } from 'redux-saga-routines';

export const externalPolisRoutine = createRoutine("EXXTERNAL_POLIS_GET");
export const externalGorloRoutine = createRoutine("EXXTERNAL_GORLO_GET");
export const externalHripyRoutine = createRoutine("EXXTERNAL_HRIPY_GET");
